export default function MobileBurgerMenu() {
    // mobile burger menu
	let burger = document.querySelector('.burger');
	let menu_body = document.querySelector('#header-menu');
	if (!menu_body) {
		menu_body = document.querySelector('.menu');
	}
    if (burger) {
        burger.onclick = function () {
            menu_body.classList.toggle('active');
            burger.classList.toggle('active')
        }
    }
}